import * as React from "react";
import { FGMaskInput } from "nsitools-react";
import "cleave.js/dist/addons/cleave-phone.be";

export interface IFGPhoneInputProps {
  name: string;
  label: string;
  requiredMark?: boolean;
  isFix?: boolean;
}

export const FGPhoneInput: React.FunctionComponent<IFGPhoneInputProps> = ({ label, name, requiredMark = false }) => {
  return (
    <FGMaskInput
      cleaveOptions={{
        phone: true,
        phoneRegionCode: "BE",
      }}
      requiredMark={requiredMark}
      name={name}
      label={label}
    />
  );
};
